import React from "react";
import { Grid, Typography } from "@material-ui/core";
import BarsChart from "./BarsChart";
import DensityChart from "./DensityChart";
import PieChart from "./PieChart";
import GreenPointChart from "./GreenPointChart";

export default function Charts() {
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={6}
        style={{
          backgroundColor: "#ebebed",
          borderBottom: "1px solid #fafafa",
        }}
      >
        <Typography variant="h5" color="textSecondary" align="center">
          Kilogramos por material
        </Typography>
        <BarsChart />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        style={{
          backgroundColor: "#ebebed",
          borderBottom: "1px solid #fafafa",
        }}
      >
        <Typography variant="h5" color="textSecondary" align="center">
          Densidad de registros por día del mes
        </Typography>
        <DensityChart />
      </Grid>
      <Grid item xs={12} md={12}>
        <PieChart />
      </Grid>
      <Grid item xs={12} md={12}>
        <Typography variant="h5" color="textSecondary" align="center">
          Kilogramos totales de recuperación por Puntos Gira
        </Typography>
        <GreenPointChart />
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
    </Grid>
  );
}
